<igx-grid #gridTipoAnticipo [primaryKey]="'IdTipoAnticipo'" [data]="dataTipoAnt" [width]="'100%'" [height]="'100%'" [locale]="localGrid"
  [allowFiltering]="true" [filterMode]="'excelStyleFilter'" [rowSelection]="activarBotones ? rowSelectionSingle : rowSelectionMultiple" [selectRowOnClick]="false" [igxGridState]="optionsGridLocal"
  [moving]="true" [sortingOptions]="sortingOptions" (rowSelectionChanging)="handleRowSelection()">
  <igx-grid-toolbar>
    <igx-grid-toolbar-title>
      <app-filtro-general-moderno #filtroGeneral descripcionLabel="{{ 'MENSAJES.GRALS.ETIQUETA_FILTRO_GRAL' | translate}}" (enterPalabra)="filterInput($event)" (limpiarPalabras)="clearInput()" />
    </igx-grid-toolbar-title>
    <igx-grid-toolbar-actions>
      <app-mas-opciones-grid #masOpcionesG [arrayDatosAVer]="[1, 2, 6]" (opcionSeleccionada)="onSelectionDropDown($event)" />
    </igx-grid-toolbar-actions>
  </igx-grid-toolbar>
  <ng-template igxSortHeaderIcon>
    <igx-icon>north</igx-icon>
  </ng-template>
  <ng-template igxSortAscendingHeaderIcon>
    <igx-icon>north</igx-icon>
  </ng-template>
  <ng-template igxSortDescendingHeaderIcon>
    <igx-icon>south</igx-icon>
  </ng-template>
  <ng-template igxExcelStyleHeaderIcon>
    <igx-icon>filter_alt</igx-icon>
  </ng-template>
  <igx-column field="DescripcionTipoAnticipo" header="{{ 'GRIDS.TIPOANTICIPO.COL_DESCRIPCIONTIPOANTICIPO' | translate}}" [dataType]="'string'" minWidth="400px" [sortable]="true" [resizable]="true" />
</igx-grid>
